import { createContext } from "react";

export const StyleBContext = createContext({ theme: "dark", toggle: () => {} });
